import { useSelector } from "react-redux";
import { getResultBy } from "../../common/input/selectors";

export default function useResultTableLayout() {
	return useSelector(getResultBy);
}
